"use strict";

document.addEventListener("DOMContentLoaded", () => {
    const trustedReviewsButton = document.getElementById("trustedstars");
    const trustedReviewsTab = document.getElementById("trusted-reviews");

    if (trustedReviewsButton && trustedReviewsTab) {
        trustedReviewsButton.addEventListener("click", (e) => {
            e.preventDefault();

            trustedReviewsTab.setAttribute("open", "");
            trustedReviewsTab.setAttribute("aria-expanded", "true");

            const detailsContent = trustedReviewsTab.querySelector(".details__content");

            if (detailsContent && getComputedStyle(detailsContent).opacity !== "1") {
                detailsContent.style.opacity = "1";
            }

            trustedReviewsTab.scrollIntoView({
                behavior: "smooth",
                block: "start"
            });
        });
    }
});